import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { loadSession } from './session';

/**
 * Gate in front of the sales flow and the admin view.
 *
 * This is convenience, not security: it decides what to render, and a determined visitor can
 * skip it. The endpoints are what actually enforce access — every protected route sits behind
 * an authorization policy on the server, and a request without a valid token is rejected there
 * whatever the client believes.
 *
 * The public report link at /r/:token is deliberately outside this gate (requirement F-30).
 */
export function RequireAuth() {
  const location = useLocation();
  const session = loadSession();

  if (!session) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <Outlet />;
}
